export const MAIN_CATEGORY = 'main_category';

export function MAIN_CATEGORY_FIELD(data: any) {
    return {
        id: MAIN_CATEGORY,
        order: 0,
        elements: [
            {
                id: MAIN_CATEGORY,
                type: 'select-2',
                name: MAIN_CATEGORY,
                label: 'Main category',
                space: 12,
                config: {
                    url: data.url + '?only-parents',
                    useScope: data.useScope || true,
                    relation: true,
                    searchKeyColumn: 'id',
                    searchQueryColumn: 'title',
                    searchDisplayColumn: 'title',
                    params: {
                        filter: 'id;code;title'
                    }
                },
                validation: {
                    // required: true,
                }
            }
        ]
    };
}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/forms/main-category-field.ts